import {Component, Input, OnInit} from '@angular/core';
import { GlobalService } from 'app/global/global.service';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {constants, ILabelValueConstant} from 'app/constants/constants';
import {AddToContractControlFormHelper} from '../add-to-contract-control-modal.component';
import {IAutoFillUploadFile} from '../create-cc-by-ai-form/ai-cc-import.service';
import {IaiProcessedData} from '../iai-processed-data.interface';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActionEnum, AddCostModalComponent } from 'app/main/pages/contract-control/modals/add-cost-modal/add-cost-modal.component';
import { ICostForm } from 'app/main/pages/contract-control/contract-control-detail-view/cc-cost/cost.dto';

@Component({
  selector: 'app-cost-form',
  templateUrl: './cost-form.component.html',
  styleUrl: './cost-form.component.scss'
})
export class CostFormComponent implements OnInit{
  @Input() contractForm: FormGroup;
  @Input() aiProcessedData: IAutoFillUploadFile;
  public mockCosts = []; // Removed mock data
  public systemCurrency: string = '';

  constructor (
    private _addToContractControlFormHelper: AddToContractControlFormHelper,
    private _modalService: NgbModal,
    private _formBuilder: FormBuilder,
    private _globalService: GlobalService
  ) {
    this.systemCurrency = this._globalService.getSystemCurrency();
  }

  ngOnInit(): void {
      if(this.aiProcessedData) {
          this.initializeWithAIProcessedData(this.aiProcessedData);
      }
  }


    /**
     * Initializes the cost form with data extracted by AI.
     * 
     * @param aiProcessedData Data extracted from a document by AI.
     */
    initializeWithAIProcessedData(aiProcessedData: IAutoFillUploadFile): void {
      // Prevent duplicating AI seeded cost when user revisits this step.
      if (this.costControls.dirty || this.costControls.length > 0) {
        return;
      }

      if (!aiProcessedData?.cost) return;

      const defaultForm = this._addToContractControlFormHelper.getCostForm().value;
      const cost_amount = isNaN(Number(aiProcessedData?.cost?.cost_amount)) ? defaultForm.cost_amount : Number(aiProcessedData?.cost?.cost_amount);
      const currency = constants.contract_control_currencies.some(x => x?.value?.toLocaleLowerCase().trim() === aiProcessedData?.cost?.cost_currency?.toLocaleLowerCase().trim()) 
        ? aiProcessedData?.cost?.cost_currency?.trim() 
        : defaultForm.cost_currency;

      const newCost: Partial<ICostForm> = {
          description: 'AI Processed Cost',
          cost_amount: cost_amount,
          cost_currency: currency,
          billing_frequency: 'monthly', // Default for AI entries if not provided
          billing_start: aiProcessedData?.period?.start_date || new Date().toISOString().split('T')[0],
          has_billing_end_date: !!aiProcessedData?.period?.end_date,
          billing_end: aiProcessedData?.period?.end_date || null
      };

      this.costControls.push(this._formBuilder.group(newCost));
    }




    /**
     * Opens the Add Cost modal dialog for adding or editing cost information.
     * 
     * @param cost Optional cost data to pre-fill the modal form.
     * @param index Optional index of the cost in the array for editing.
     */
    openCostFormModal(cost?: ICostForm, index?: number): void {
      const modalRef$ = this._modalService.open(AddCostModalComponent, {size: 'md', backdrop: 'static'});
      modalRef$.componentInstance.cost = cost;
      modalRef$.componentInstance.document_type_id = this.contractForm.get('contractForm')?.get('document_type_id')?.value;
      modalRef$.componentInstance.contract_control_id = null;
      modalRef$.componentInstance.actionFrom = ActionEnum.CREATING_CONTRACT;
      modalRef$.componentInstance.hasPermission = true;
      modalRef$.result.then((result: ICostForm) => {
          if(result) {
            if (index !== undefined) {
              this.costControls.at(index).patchValue(result);
            } else {
              this.costControls.push(this._formBuilder.group(result));
            }
            this.costControls.markAsDirty();
          }
      });
    }

    /**
     * Removes a cost from the FormArray.
     * @param index The index of the cost to remove.
     */
    removeCost(index: number): void {
      this.costControls.removeAt(index);
      this.costControls.markAsDirty();
    }




    get costControls() {
      return this.contractForm.get('costForm') as FormArray;
    }

}
